import { TrackingEvent, type Traits } from '../types'

export interface CoreIdentifyProperties {
  traits?: Traits
  userId?: string
}

export class CoreIdentify extends TrackingEvent {
  properties: CoreIdentifyProperties

  constructor(args: CoreIdentifyProperties) {
    const {
      userId = undefined,
      traits = {
        email: '',
        address: {
          street: '',
          state: '',
          postalCode: '',
          city: '',
        },
      },
    } = args ?? {}

    super('CoreIdentify', 'core.Identify.v1')

    this.properties = {
      userId: userId ?? undefined,
      traits: {
        email: traits.email,
        address: traits.address,
      },
    }
  }
}
